import { useCallback } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { useGoBack } from '@libs/hooks/useGoBack';

import { PlayerProfilePageWidget } from '@features/user/pages/PlayerProfilePage/PlayerProfilePageWidget';

export const Route = createFileRoute('/profile/clubs-and-tournaments/')({
  component: RouteComponent,
});

function RouteComponent() {
  const goBackRoot = useGoBack({
    to: '/profile',
    from: '/',
    replace: true,
  });
  const setIsClubsAndTournamentsOpen = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) {
        goBackRoot();
      }
    },
    [goBackRoot],
  );

  const goBackStats = useGoBack({
    to: '/profile/stats',
    from: '/',
    replace: true,
  });
  const setIsEloStatsModalOpen = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) {
        goBackStats();
      }
    },
    [goBackStats],
  );

  return (
    <PlayerProfilePageWidget
      isClubsAndTournamentsOpen
      isEloStatsModalOpen={false}
      setIsEloStatsModalOpen={setIsEloStatsModalOpen}
      setIsClubsAndTournamentsOpen={setIsClubsAndTournamentsOpen}
    />
  );
}
